module.exports = __webpack_public_path__ + "static/media/4.b5d9eb26.jpg";